export default __webpack_public_path__ + "static/media/img-0464-montenegro-half-face.0d57721c.png";